var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftware2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.338 42.662H226.675A8 8 0 0 1 234.675 50.662V205.325A8 8 0 0 1 226.675 213.325H29.338A8 8 0 0 1 21.338 205.325V50.662A8 8 0 0 1 29.338 42.662ZM21.338 96L234.662 96M58.662 69.338L58.778 69.338M85.338 69.338L85.44 69.338M96 128L74.662 149.338L96 170.662M160 128L181.338 149.338L160 170.662M138.662 122.662L117.338 176",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware2);
export default __webpack_public_path__ + "static/media/software-2.35365f3ac443ef583387483fe5bdc3d5.svg";
export { ForwardRef as ReactComponent };